import {
  DataProvider,
  IErrorModel,
  useCurrentUserSelector,
  useQuery,
} from "@nf/common";

const getPaymentDetails = () => DataProvider.getPaymentDetails();

export const useGetPaymentDetails = (enabled: boolean) => {
  const userId = useCurrentUserSelector()?.Id;

  const { data, error, isLoading } = useQuery(
    `payment-details-${userId}`,
    getPaymentDetails,
    { enabled: enabled && !!userId }
  );

  return {
    data: data ?? undefined,
    error: (error ?? undefined) as IErrorModel | undefined,
    isLoading,
  };
};
